import { apiSlice } from "../../app/api/apiSlice";

export const legalApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // Query to pull public data logs down the road
    getLegalDocument: builder.query({
      query: (slug) => ({
        url: `/legal/${slug}`,
        method: "GET",
      }),
      providesTags: (result, error, slug) => [
        { type: "LegalDocuments", id: slug },
      ],
    }),

    // Mutation tracking block allowing an Admin dashboard panel to modify values
    updateLegalDocument: builder.mutation({
      query: ({ slug, ...documentData }) => ({
        url: `/legal/${slug}`,
        method: "PUT",
        body: documentData,
      }),
      // Automatically invalidates cached data to force a background recalculation
      invalidatesTags: (result, error, { slug }) => [
        { type: "LegalDocuments", id: slug },
      ],
    }),
  }),
});

export const { useGetLegalDocumentQuery, useUpdateLegalDocumentMutation } =
  legalApiSlice;
